import { ContentContainer } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { BulkFiltersBar } from '../../bulk/BulkFiltersBar';
import { BulkList } from '../../bulk/BulkList';

export function BulkPage() {
  const [reloadPage, setReloadPage] = useState(false);

  return (
    <ContentContainer>
      <BulkFiltersBar onReloadPage={() => setReloadPage(!reloadPage)} />
      <BulkList reloadPage={reloadPage} />
    </ContentContainer>
  );
}
